import PropTypes from 'prop-types';
import { Button } from '@bwoty-web/ui-kit';
import { getPaxFormText } from '../../utils/pax/helper';

import './compressedHotelSearch.scss';

const CompressedHotelSearch = ({
  isLoading,
  labels,
  departure,
  duration,
  rooms,
  expand,
}) => {
  return (
    <div className="compressed-hotel-search">
      <div className="compressed-hotel-search__left">
        <div className="compressed-hotel-search__heading">
          {labels.hotelSearchCompressedHeading}
        </div>
        <div className="compressed-hotel-search__travel-info">
          {isLoading ? (
            <div className="bs-fake-ui" />
          ) : (
            <div>
              <span>{`${departure.name},`}</span>
              <span>{`${duration},`}</span>
              <span>{getPaxFormText(rooms, labels)}</span>
            </div>
          )}
        </div>
      </div>
      <div className="compressed-hotel-search__right">
        <Button
          variant="ghost"
          className="compressed-hotel-search__button"
          onClick={() => expand()}
          disabled={isLoading}
        >
          {labels.changeButtonLabel}
        </Button>
      </div>
    </div>
  );
};

CompressedHotelSearch.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    changeButtonLabel: PropTypes.string,
    hotelSearchCompressedHeading: PropTypes.string,
  }).isRequired,
  departure: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  duration: PropTypes.string.isRequired,
  rooms: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  expand: PropTypes.func.isRequired,
};

export default CompressedHotelSearch;
